// src/components/ContentTypeInitializer.js

import { useEffect } from 'react';
import useAxios from './../utils/useAxios';
import { initializeContentTypes } from './../utils/contentTypes';

const ContentTypeInitializer = () => {
  const api = useAxios();

  useEffect(() => {
    if (api) {
      initializeContentTypes(api);
    }
  }, [api]);

  return null; // This component doesn't render anything
};

export default ContentTypeInitializer;